<template>
  <AppHeader @clickShowDownloadMobile="handleDownloadMob"
             @openChatWidget="openChatWidget"
  />
  <BannerSlider />
  <ServicesShortcuts @openChatWidget="openChatWidget"/>
  <ActivateService />
  <ServiceForBusiness />
  <News />
  <Partners />
  <AppFooter @open-chat-widget="openChatWidget()"/>
  <MobileDownload ref="mobDownload"/>
  <PayWidget :hide-text="true" :section="'Kazakhtelecom_Business_MAIN'" :auth="userStore.isAuth"/>
  <KtCallback :showComment="true"/>
  <ChatWidget :tabTitle="$t('title')" ref="chatWidget" :userInfo="userStore.userProfile"/>
</template>

<script setup>
import AppHeader from "@/components/layout/AppHeader.vue";
import ActivateService from "@/components/reused/ActivateService.vue";
import News from "@/components/reused/News.vue";
import BannerSlider from "@/components/reused/BannerSlider.vue";
import Partners from "@/components/reused/Partners.vue";
import AppFooter from "@/components/layout/AppFooter.vue";
import ServicesShortcuts from "@/components/reused/ServicesShortcuts.vue";
import ServiceForBusiness from "@/components/reused/ServiceForBusiness.vue";
import {useTemplateRef, watch} from "vue";
import { useHead } from '@unhead/vue'
import {useI18n} from "vue-i18n";
import {KtCallback, PayWidget} from "@ismet/vue-ui-kit";
import {useUserStore} from "@/stores.ts";

const { t, locale } = useI18n()
const mobileDownload = useTemplateRef('mobDownload')
const chatWidget = useTemplateRef('chatWidget')
const userStore = useUserStore()

const handleDownloadMob = (type) => {
  mobileDownload.value?.open(type);
}

const openChatWidget = () => {
  chatWidget.value?.open()
}

const config = () => {
  return {
    htmlAttrs: {
      lang: locale.value
    },
    title: t('title'),
    meta: [
      {
        name: 'description',
        content: t('description'),
      },
      {
        property: 'og:title',
        content: t('title'),
      },
      {
        property: 'og:description',
        content: t('description'),
      },
      {
        property: 'og:image',
        content: `${import.meta.env.VITE_HOST}/preview.png`,
      },
      {
        property: 'og:url',
        content: `${import.meta.env.VITE_HOST}/${locale.value === 'kk' ? '' : locale.value}`,
      },
      {
        property: 'og:locale',
        content: `${locale.value === 'ru' ? 'ru_RU' : locale.value === 'kk' ? 'kk_KZ' : 'en_US'}`,
      }
    ]
  }
}

const head = useHead(config())
watch(locale, () => {
  head.patch(config())
})
</script>

<style lang="scss">
</style>
